// In a room the title of the tab says when the turn comes to this screen, so a
// player who went to another tab while the other person thought sees it there.
// Alone with the AI the title does not change: the AI is fast.

import { gameStore } from './game';
import { actsFor } from './localSide';
import { isMatchWaiting, matchWaitStore } from './matchWait';
import { roomStore } from './roomStore';

/** Plain words, not final copy. */
const YOUR_MOVE_PREFIX = '● Your move · ';

/** Call once at startup, after the title is set. */
export const startTabTitle = (): void => {
  const plain = document.title;
  const draw = (): void => {
    const state = gameStore.get();
    const yours =
      roomStore.get() !== null &&
      !isMatchWaiting() &&
      state.phase !== 'over' &&
      actsFor(state.turn);
    document.title = yours ? `${YOUR_MOVE_PREFIX}${plain}` : plain;
  };
  gameStore.subscribe(draw);
  roomStore.subscribe(draw);
  matchWaitStore.subscribe(draw);
  draw();
};
